import {Card, FormControl} from 'platform/components';
import {Grid, GridItem, VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';
import {SupplierArticleUpdateScope} from './SupplierArticleUpdateScope';
import {WarehouseArticleUpdateScope} from './WarehouseArticleUpdateScope';

interface UpdateScopeFormProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  formApi: UseFormReturn<OverviewForm>;
}

export function UpdateScopeForm(props: UpdateScopeFormProps) {
  return (
    <Card
      hasSeparator
      title={i18n.t('entity.warehouse.labels.updateScope')}
      variant="inlineGrey"
      tooltip={i18n.t('entity.warehouse.labels.updateScopeTooltip')}
    >
      <VStack spacing={4}>
        <Grid columns={3} spacing={4}>
          <GridItem span={1}>
            <SupplierArticleUpdateScope
              control={props.control}
              formApi={props.formApi}
              data-testid={suffixTestId('supplierArticleUpdateScope', props)}
            />
          </GridItem>
          <GridItem span={1}>
            <WarehouseArticleUpdateScope
              control={props.control}
              formApi={props.formApi}
              data-testid={suffixTestId('warehouseArticleUpdateScope', props)}
            />
          </GridItem>
        </Grid>
      </VStack>
    </Card>
  );
}
